import React from 'react';

/**
 * Highlights occurrences of the search query in text
 * @param {string} text - The text to highlight search terms in
 * @param {string} searchQuery - The search query to highlight
 * @returns {string|JSX.Element[]} - Either the original text or array of text segments with highlights
 */
export const highlightSearchText = (text, searchQuery) => {
  if (!searchQuery || !text) return text;
  
  const regex = new RegExp(`(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);
  
  if (parts.length === 1) return text;
  
  return parts.map((part, index) => {
    if (index % 2 === 1) {
      // This part matches the search query
      return <span key={index} className="bg-yellow-500/30 text-white font-medium">{part}</span>;
    }
    return part;
  });
};

export default highlightSearchText;